import { render, staticRenderFns } from "./CreateWheelLockController.vue?vue&type=template&id=63420e66&"
import script from "./CreateWheelLockController.vue?vue&type=script&lang=js&"
export * from "./CreateWheelLockController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports